import { render, staticRenderFns } from "./PlanVideos.vue?vue&type=template&id=01aa1a88&scoped=true&"
import script from "./PlanVideos.vue?vue&type=script&lang=js&"
export * from "./PlanVideos.vue?vue&type=script&lang=js&"
import style0 from "./PlanVideos.vue?vue&type=style&index=0&id=01aa1a88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01aa1a88",
  null
  
)

export default component.exports